module.exports = __webpack_public_path__ + "static/media/stamp-2.e1f229e9.png";